module.exports = __webpack_public_path__ + "img/4.5c11e291.jpg";